import React from 'react';

export const PageSection = (props) => {
  return (
    <div className={`${props.className ?? ''} pageSection`}>
      {props.children}
    </div>
  );
};
